module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAEKSURBVEiJ1ZQ9TsNAEIW/WVJQQE8ZJEoXXAZxghQUiYT4dUGFkKOsKNgcApA4DEdIEYkDOAUF2aEhIOzYxCuvJV45mve9nf2DrpVZl2fW5W35esWCwE7Iwqp8cmcfki2VW+Dwq7MPgDJrmFD0vS5Fb3oGeURIKg1N9ePrG+TACGvgLUkgMbHgK0UP+L5F+rHcT9PTWVvgsXUKHUzQ3RatNLmfHqv67RCYiHm/PBs+1wZ4r08gIXxUFaA+QIQj78O+C2NYFGulgKvz0UsIvDK0Tdg6lSbIrMs3/VEVFunFaLeupzRBk+PdpLc0wfUfK2qq//+SZWzdG7AXiT83Xv0AmMeAe/UnEbi/9Qmn40dcv4zOIQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/public/components/kye-date-picker3/src/images/date.png
// module id = xi/G
// module chunks = 7